export const rowsChartLaThanh_v5 = [
    //row C,
    {
      labelRow: "A",
      coordinates: [
        { cx: 53.969, cy: 276.735 },
        { cx: 75.366, cy: 276.735 },
        { cx: 96.972, cy: 276.735 },
        { cx: 118.369, cy: 276.735 },
        { cx: 139.974, cy: 276.735 },
        { cx: 161.372, cy: 276.735 },
        { cx: 236.584, cy: 276.735 },
        { cx: 257.981, cy: 276.735 },
        { cx: 279.587, cy: 276.735 },
        { cx: 300.984, cy: 276.735 },
        { cx: 322.59, cy: 276.735 },
        { cx: 343.987, cy: 276.735 },
        { cx: 364.626, cy: 276.735 },
        { cx: 386.023, cy: 276.735 },
        { cx: 492.972, cy: 276.735 },
        { cx: 514.369, cy: 276.735 },
        { cx: 535.974, cy: 276.735 },
        { cx: 557.371, cy: 276.735 },
        { cx: 578.977, cy: 276.735 },
        { cx: 600.374, cy: 276.735 },
        { cx: 621.014, cy: 276.735 },
        { cx: 642.411, cy: 276.735 },
        { cx: 718.106, cy: 276.735 },
        { cx: 739.504, cy: 276.735 },
        { cx: 761.109, cy: 276.735 },
        { cx: 782.506, cy: 276.735 },
        { cx: 804.112, cy: 276.735 },
        { cx: 825.509, cy: 276.735 }
      ]
    },
    // row D,
    {
      labelRow: "B",
      coordinates: [
        { cx: 52.32, cy: 322.607 },
        { cx: 68.208, cy: 322.607 },
        { cx: 84.096, cy: 322.607 },
        { cx: 99.984, cy: 322.607 },
        { cx: 115.872, cy: 322.607 },
        { cx: 131.76, cy: 322.607 },
        { cx: 147.649, cy: 322.607 },
        { cx: 163.537, cy: 322.607 },
        { cx: 715.958, cy: 322.607 },
        { cx: 731.846, cy: 322.607 },
        { cx: 747.734, cy: 322.607 },
        { cx: 763.622, cy: 322.607 },
        { cx: 779.51, cy: 322.607 },
        { cx: 795.398, cy: 322.607 },
        { cx: 811.286, cy: 322.607 },
        { cx: 827.175, cy: 322.607 },
        { cx: 234.446, cy: 322.607 },
        { cx: 251.656, cy: 322.607 },
        { cx: 268.867, cy: 322.607 },
        { cx: 286.078, cy: 322.607 },
        { cx: 303.288, cy: 322.607 },
        { cx: 320.499, cy: 322.607 },
        { cx: 337.71, cy: 322.607 },
        { cx: 354.92, cy: 322.607 },
        { cx: 372.131, cy: 322.607 },
        { cx: 389.342, cy: 322.607 },
        { cx: 490.243, cy: 322.607 },
        { cx: 507.454, cy: 322.607 },
        { cx: 524.665, cy: 322.607 },
        { cx: 541.875, cy: 322.607 },
        { cx: 559.086, cy: 322.607 },
        { cx: 576.296, cy: 322.607 },
        { cx: 593.507, cy: 322.607 },
        { cx: 610.718, cy: 322.607 },
        { cx: 627.928, cy: 322.607 },
        { cx: 645.139, cy: 322.607 }
      ]
    },
    //row C,
    {
      labelRow: "C",
      coordinates: [
        { cx: 52.32, cy: 368.479 },
        { cx: 68.208, cy: 368.479 },
        { cx: 84.096, cy: 368.479 },
        { cx: 99.984, cy: 368.479 },
        { cx: 115.872, cy: 368.479 },
        { cx: 131.76, cy: 368.479 },
        { cx: 147.649, cy: 368.479 },
        { cx: 163.537, cy: 368.479 },
        { cx: 715.958, cy: 368.479 },
        { cx: 731.846, cy: 368.479 },
        { cx: 747.734, cy: 368.479 },
        { cx: 763.622, cy: 368.479 },
        { cx: 779.51, cy: 368.479 },
        { cx: 795.398, cy: 368.479 },
        { cx: 811.286, cy: 368.479 },
        { cx: 827.175, cy: 368.479 },
        { cx: 234.446, cy: 368.479 },
        { cx: 251.656, cy: 368.479 },
        { cx: 268.867, cy: 368.479 },
        { cx: 286.078, cy: 368.479 },
        { cx: 303.288, cy: 368.479 },
        { cx: 320.499, cy: 368.479 },
        { cx: 337.71, cy: 368.479 },
        { cx: 354.92, cy: 368.479 },
        { cx: 372.131, cy: 368.479 },
        { cx: 389.342, cy: 368.479 },
        { cx: 490.243, cy: 368.479 },
        { cx: 507.454, cy: 368.479 },
        { cx: 524.665, cy: 368.479 },
        { cx: 541.875, cy: 368.479 },
        { cx: 559.086, cy: 368.479 },
        { cx: 576.296, cy: 368.479 },
        { cx: 593.507, cy: 368.479 },
        { cx: 610.718, cy: 368.479 },
        { cx: 627.928, cy: 368.479 },
        { cx: 645.139, cy: 368.479 }
      ]
    },
    //row D,
    {
      labelRow: "D",
      coordinates: [
        { cx: 52.32, cy: 414.351 },
        { cx: 68.208, cy: 414.351 },
        { cx: 84.096, cy: 414.351 },
        { cx: 99.984, cy: 414.351 },
        { cx: 115.872, cy: 414.351 },
        { cx: 131.76, cy: 414.351 },
        { cx: 147.649, cy: 414.351 },
        { cx: 163.537, cy: 414.351 },
        { cx: 715.958, cy: 414.351 },
        { cx: 731.846, cy: 414.351 },
        { cx: 747.734, cy: 414.351 },
        { cx: 763.622, cy: 414.351 },
        { cx: 779.51, cy: 414.351 },
        { cx: 795.398, cy: 414.351 },
        { cx: 811.286, cy: 414.351 },
        { cx: 827.175, cy: 414.351 },
        { cx: 234.446, cy: 414.351 },
        { cx: 251.656, cy: 414.351 },
        { cx: 268.867, cy: 414.351 },
        { cx: 286.078, cy: 414.351 },
        { cx: 303.288, cy: 414.351 },
        { cx: 320.499, cy: 414.351 },
        { cx: 337.71, cy: 414.351 },
        { cx: 354.92, cy: 414.351 },
        { cx: 372.131, cy: 414.351 },
        { cx: 389.342, cy: 414.351 },
        { cx: 490.243, cy: 414.351 },
        { cx: 507.454, cy: 414.351 },
        { cx: 524.665, cy: 414.351 },
        { cx: 541.875, cy: 414.351 },
        { cx: 559.086, cy: 414.351 },
        { cx: 576.296, cy: 414.351 },
        { cx: 593.507, cy: 414.351 },
        { cx: 610.718, cy: 414.351 },
        { cx: 627.928, cy: 414.351 },
        { cx: 645.139, cy: 414.351 }
      ]
    },
     //row G,
    {
      labelRow: "E",
      coordinates: [
        { cx: 52.32, cy: 460.223 },
        { cx: 68.208, cy: 460.223 },
        { cx: 84.096, cy: 460.223 },
        { cx: 99.984, cy: 460.223 },
        { cx: 115.872, cy: 460.223 },
        { cx: 131.76, cy: 460.223 },
        { cx: 147.649, cy: 460.223 },
        { cx: 163.537, cy: 460.223 },
        { cx: 715.958, cy: 460.223 },
        { cx: 731.846, cy: 460.223 },
        { cx: 747.734, cy: 460.223 },
        { cx: 763.622, cy: 460.223 },
        { cx: 779.51, cy: 460.223 },
        { cx: 795.398, cy: 460.223 },
        { cx: 811.286, cy: 460.223 },
        { cx: 827.175, cy: 460.223 },
        { cx: 234.446, cy: 460.223 },
        { cx: 251.656, cy: 460.223 },
        { cx: 268.867, cy: 460.223 },
        { cx: 286.078, cy: 460.223 },
        { cx: 303.288, cy: 460.223 },
        { cx: 320.499, cy: 460.223 },
        { cx: 337.71, cy: 460.223 },
        { cx: 354.92, cy: 460.223 },
        { cx: 372.131, cy: 460.223 },
        { cx: 389.342, cy: 460.223 },
        { cx: 490.243, cy: 460.223 },
        { cx: 507.454, cy: 460.223 },
        { cx: 524.665, cy: 460.223 },
        { cx: 541.875, cy: 460.223 },
        { cx: 559.086, cy: 460.223 },
        { cx: 576.296, cy: 460.223 },
        { cx: 593.507, cy: 460.223 },
        { cx: 610.718, cy: 460.223 },
        { cx: 627.928, cy: 460.223 },
        { cx: 645.139, cy: 460.223 }
      ]
    },
     //row H,
    {
      labelRow: "F",
      coordinates: [
        { cx: 52.32, cy: 506.095 },
        { cx: 68.208, cy: 506.095 },
        { cx: 84.096, cy: 506.095 },
        { cx: 99.984, cy: 506.095 },
        { cx: 115.872, cy: 506.095 },
        { cx: 131.76, cy: 506.095 },
        { cx: 147.649, cy: 506.095 },
        { cx: 163.537, cy: 506.095 },
        { cx: 715.958, cy: 506.095 },
        { cx: 731.846, cy: 506.095 },
        { cx: 747.734, cy: 506.095 },
        { cx: 763.622, cy: 506.095 },
        { cx: 779.51, cy: 506.095 },
        { cx: 795.398, cy: 506.095 },
        { cx: 811.286, cy: 506.095 },
        { cx: 827.175, cy: 506.095 },
        { cx: 234.446, cy: 506.095 },
        { cx: 251.656, cy: 506.095 },
        { cx: 268.867, cy: 506.095 },
        { cx: 286.078, cy: 506.095 },
        { cx: 303.288, cy: 506.095 },
        { cx: 320.499, cy: 506.095 },
        { cx: 337.71, cy: 506.095 },
        { cx: 354.92, cy: 506.095 },
        { cx: 372.131, cy: 506.095 },
        { cx: 389.342, cy: 506.095 },
        { cx: 490.243, cy: 506.095 },
        { cx: 507.454, cy: 506.095 },
        { cx: 524.665, cy: 506.095 },
        { cx: 541.875, cy: 506.095 },
        { cx: 559.086, cy: 506.095 },
        { cx: 576.296, cy: 506.095 },
        { cx: 593.507, cy: 506.095 },
        { cx: 610.718, cy: 506.095 },
        { cx: 627.928, cy: 506.095 },
        { cx: 645.139, cy: 506.095 }
      ]
    },

    //cách 1 hàng
    //*********************************************************************/
    //bỏ trống một hàng

    //row I,
    {
      labelRow: "G",
      coordinates: [
        { cx: 52.32, cy: 579.504 },
        { cx: 68.208, cy: 579.504 },
        { cx: 84.096, cy: 579.504 },
        { cx: 99.984, cy: 579.504 },
        { cx: 115.872, cy: 579.504 },
        { cx: 131.76, cy: 579.504 },
        { cx: 147.649, cy: 579.504 },
        { cx: 163.537, cy: 579.504 },
        { cx: 715.958, cy: 579.504 },
        { cx: 731.846, cy: 579.504 },
        { cx: 747.734, cy: 579.504 },
        { cx: 763.622, cy: 579.504 },
        { cx: 779.51, cy: 579.504 },
        { cx: 795.398, cy: 579.504 },
        { cx: 811.286, cy: 579.504 },
        { cx: 827.175, cy: 579.504 },
        { cx: 234.446, cy: 579.504 },
        { cx: 251.656, cy: 579.504 },
        { cx: 268.867, cy: 579.504 },
        { cx: 286.078, cy: 579.504 },
        { cx: 303.288, cy: 579.504 },
        { cx: 320.499, cy: 579.504 },
        { cx: 337.71, cy: 579.504 },
        { cx: 354.92, cy: 579.504 },
        { cx: 372.131, cy: 579.504 },
        { cx: 389.342, cy: 579.504 },
        { cx: 490.243, cy: 579.504 },
        { cx: 507.454, cy: 579.504 },
        { cx: 524.665, cy: 579.504 },
        { cx: 541.875, cy: 579.504 },
        { cx: 559.086, cy: 579.504 },
        { cx: 576.296, cy: 579.504 },
        { cx: 593.507, cy: 579.504 },
        { cx: 610.718, cy: 579.504 },
        { cx: 627.928, cy: 579.504 },
        { cx: 645.139, cy: 579.504 }
      ]
    },
     //row K: 28 ghế,
    {
      labelRow: "H",
      coordinates: [
        { cx: 52.32, cy: 625.376 },
        { cx: 68.208, cy: 625.376 },
        { cx: 84.096, cy: 625.376 },
        { cx: 99.984, cy: 625.376 },
        { cx: 115.872, cy: 625.376 },
        { cx: 131.76, cy: 625.376 },
        { cx: 147.649, cy: 625.376 },
        { cx: 163.537, cy: 625.376 },
        { cx: 715.958, cy: 625.376 },
        { cx: 731.846, cy: 625.376 },
        { cx: 747.734, cy: 625.376 },
        { cx: 763.622, cy: 625.376 },
        { cx: 779.51, cy: 625.376 },
        { cx: 795.398, cy: 625.376 },
        { cx: 811.286, cy: 625.376 },
        { cx: 827.175, cy: 625.376 },
        { cx: 234.446, cy: 625.376 },
        { cx: 251.656, cy: 625.376 },
        { cx: 268.867, cy: 625.376 },
        { cx: 286.078, cy: 625.376 },
        { cx: 303.288, cy: 625.376 },
        { cx: 320.499, cy: 625.376 },
        { cx: 337.71, cy: 625.376 },
        { cx: 354.92, cy: 625.376 },
        { cx: 372.131, cy: 625.376 },
        { cx: 389.342, cy: 625.376 },
        { cx: 490.243, cy: 625.376 },
        { cx: 507.454, cy: 625.376 },
        { cx: 524.665, cy: 625.376 },
        { cx: 541.875, cy: 625.376 },
        { cx: 559.086, cy: 625.376 },
        { cx: 576.296, cy: 625.376 },
        { cx: 593.507, cy: 625.376 },
        { cx: 610.718, cy: 625.376 },
        { cx: 627.928, cy: 625.376 },
        { cx: 645.139, cy: 625.376 }
      ]
    },

     //row L
    {
      labelRow: "J",
      coordinates: [
        { cx: 52.32, cy: 671.248 },
        { cx: 68.208, cy: 671.248 },
        { cx: 84.096, cy: 671.248 },
        { cx: 99.984, cy: 671.248 },
        { cx: 115.872, cy: 671.248 },
        { cx: 131.76, cy: 671.248 },
        { cx: 147.649, cy: 671.248 },
        { cx: 163.537, cy: 671.248 },
        { cx: 715.958, cy: 671.248 },
        { cx: 731.846, cy: 671.248 },
        { cx: 747.734, cy: 671.248 },
        { cx: 763.622, cy: 671.248 },
        { cx: 779.51, cy: 671.248 },
        { cx: 795.398, cy: 671.248 },
        { cx: 811.286, cy: 671.248 },
        { cx: 827.175, cy: 671.248 },
        { cx: 234.446, cy: 671.248 },
        { cx: 251.656, cy: 671.248 },
        { cx: 268.867, cy: 671.248 },
        { cx: 286.078, cy: 671.248 },
        { cx: 303.288, cy: 671.248 },
        { cx: 320.499, cy: 671.248 },
        { cx: 337.71, cy: 671.248 },
        { cx: 354.92, cy: 671.248 },
        { cx: 372.131, cy: 671.248 },
        { cx: 389.342, cy: 671.248 },
        { cx: 490.243, cy: 671.248 },
        { cx: 507.454, cy: 671.248 },
        { cx: 524.665, cy: 671.248 },
        { cx: 541.875, cy: 671.248 },
        { cx: 559.086, cy: 671.248 },
        { cx: 576.296, cy: 671.248 },
        { cx: 593.507, cy: 671.248 },
        { cx: 610.718, cy: 671.248 },
        { cx: 627.928, cy: 671.248 },
        { cx: 645.139, cy: 671.248 }
      ]
    },    //row M,
    {
      labelRow: "K",
      coordinates: [
        { cx: 52.32, cy: 717.120 },
        { cx: 68.208, cy: 717.120 },
        { cx: 84.096, cy: 717.120 },
        { cx: 99.984, cy: 717.120 },
        { cx: 115.872, cy: 717.120 },
        { cx: 131.76, cy: 717.120 },
        { cx: 147.649, cy: 717.120 },
        { cx: 163.537, cy: 717.120 },
        { cx: 715.958, cy: 717.120 },
        { cx: 731.846, cy: 717.120 },
        { cx: 747.734, cy: 717.120 },
        { cx: 763.622, cy: 717.120 },
        { cx: 779.51, cy: 717.120 },
        { cx: 795.398, cy: 717.120 },
        { cx: 811.286, cy: 717.120 },
        { cx: 827.175, cy: 717.120 },
        { cx: 234.446, cy: 717.120 },
        { cx: 251.656, cy: 717.120 },
        { cx: 268.867, cy: 717.120 },
        { cx: 286.078, cy: 717.120 },
        { cx: 303.288, cy: 717.120 },
        { cx: 320.499, cy: 717.120 },
        { cx: 337.71, cy: 717.120 },
        { cx: 354.92, cy: 717.120 },
        { cx: 372.131, cy: 717.120 },
        { cx: 389.342, cy: 717.120 },
        { cx: 490.243, cy: 717.120 },
        { cx: 507.454, cy: 717.120 },
        { cx: 524.665, cy: 717.120 },
        { cx: 541.875, cy: 717.120 },
        { cx: 559.086, cy: 717.120 },
        { cx: 576.296, cy: 717.120 },
        { cx: 593.507, cy: 717.120 },
        { cx: 610.718, cy: 717.120 },
        { cx: 627.928, cy: 717.120 },
        { cx: 645.139, cy: 717.120 }
      ]
    },    //row N,
    {
      labelRow: "L",
      coordinates: [
        { cx: 52.32, cy: 762.992 },
        { cx: 68.208, cy: 762.992 },
        { cx: 84.096, cy: 762.992 },
        { cx: 99.984, cy: 762.992 },
        { cx: 115.872, cy: 762.992 },
        { cx: 131.76, cy: 762.992 },
        { cx: 147.649, cy: 762.992 },
        { cx: 163.537, cy: 762.992 },
        { cx: 715.958, cy: 762.992 },
        { cx: 731.846, cy: 762.992 },
        { cx: 747.734, cy: 762.992 },
        { cx: 763.622, cy: 762.992 },
        { cx: 779.51, cy: 762.992 },
        { cx: 795.398, cy: 762.992 },
        { cx: 811.286, cy: 762.992 },
        { cx: 827.175, cy: 762.992 },
        { cx: 234.446, cy: 762.992 },
        { cx: 251.656, cy: 762.992 },
        { cx: 268.867, cy: 762.992 },
        { cx: 286.078, cy: 762.992 },
        { cx: 303.288, cy: 762.992 },
        { cx: 320.499, cy: 762.992 },
        { cx: 337.71, cy: 762.992 },
        { cx: 354.92, cy: 762.992 },
        { cx: 372.131, cy: 762.992 },
        { cx: 389.342, cy: 762.992 },
        { cx: 490.243, cy: 762.992 },
        { cx: 507.454, cy: 762.992 },
        { cx: 524.665, cy: 762.992 },
        { cx: 541.875, cy: 762.992 },
        { cx: 559.086, cy: 762.992 },
        { cx: 576.296, cy: 762.992 },
        { cx: 593.507, cy: 762.992 },
        { cx: 610.718, cy: 762.992 },
        { cx: 627.928, cy: 762.992 },
        { cx: 645.139, cy: 762.992 }
      ]
    },    //row P,
    {
      labelRow: "M",
      coordinates: [
        { cx: 52.32, cy: 808.864 },
        { cx: 68.208, cy: 808.864 },
        { cx: 84.096, cy: 808.864 },
        { cx: 99.984, cy: 808.864 },
        { cx: 115.872, cy: 808.864 },
        { cx: 131.76, cy: 808.864 },
        { cx: 147.649, cy: 808.864 },
        { cx: 163.537, cy: 808.864 },
        { cx: 715.958, cy: 808.864 },
        { cx: 731.846, cy: 808.864 },
        { cx: 747.734, cy: 808.864 },
        { cx: 763.622, cy: 808.864 },
        { cx: 779.51, cy: 808.864 },
        { cx: 795.398, cy: 808.864 },
        { cx: 811.286, cy: 808.864 },
        { cx: 827.175, cy: 808.864 },
        { cx: 234.446, cy: 808.864 },
        { cx: 251.656, cy: 808.864 },
        { cx: 268.867, cy: 808.864 },
        { cx: 286.078, cy: 808.864 },
        { cx: 303.288, cy: 808.864 },
        { cx: 320.499, cy: 808.864 },
        { cx: 337.71, cy: 808.864 },
        { cx: 354.92, cy: 808.864 },
        { cx: 372.131, cy: 808.864 },
        { cx: 389.342, cy: 808.864 },
        { cx: 490.243, cy: 808.864 },
        { cx: 507.454, cy: 808.864 },
        { cx: 524.665, cy: 808.864 },
        { cx: 541.875, cy: 808.864 },
        { cx: 559.086, cy: 808.864 },
        { cx: 576.296, cy: 808.864 },
        { cx: 593.507, cy: 808.864 },
        { cx: 610.718, cy: 808.864 },
        { cx: 627.928, cy: 808.864 },
        { cx: 645.139, cy: 808.864 }
      ]
    },    //row Q,
    {
      labelRow: "N",
      coordinates: [
        { cx: 52.32, cy: 840.161 },
        { cx: 68.208, cy: 840.161 },
        { cx: 84.096, cy: 840.161 },
        { cx: 99.984, cy: 840.161 },
        { cx: 115.872, cy: 840.161 },
        { cx: 131.76, cy: 840.161 },
        { cx: 147.649, cy: 840.161 },
        { cx: 163.537, cy: 840.161 },
        { cx: 715.958, cy: 840.161 },
        { cx: 731.846, cy: 840.161 },
        { cx: 747.734, cy: 840.161 },
        { cx: 763.622, cy: 840.161 },
        { cx: 779.51, cy: 840.161 },
        { cx: 795.398, cy: 840.161 },
        { cx: 811.286, cy: 840.161 },
        { cx: 827.175, cy: 840.161 },
        { cx: 234.446, cy: 840.161 },
        { cx: 251.656, cy: 840.161 },
        { cx: 268.867, cy: 840.161 },
        { cx: 286.078, cy: 840.161 },
        { cx: 303.288, cy: 840.161 },
        { cx: 320.499, cy: 840.161 },
        { cx: 337.71, cy: 840.161 },
        { cx: 354.92, cy: 840.161 },
        { cx: 372.131, cy: 840.161 },
        { cx: 389.342, cy: 840.161 },
        { cx: 490.243, cy: 840.161 },
        { cx: 507.454, cy: 840.161 },
        { cx: 524.665, cy: 840.161 },
        { cx: 541.875, cy: 840.161 },
        { cx: 559.086, cy: 840.161 },
        { cx: 576.296, cy: 840.161 },
        { cx: 593.507, cy: 840.161 },
        { cx: 610.718, cy: 840.161 },
        { cx: 627.928, cy: 840.161 },
        { cx: 645.139, cy: 840.161 }
      ]
    }
];
 